import { AfterViewChecked, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Inject, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { HomeService } from '../../../services/home/home.service';
import { DOCUMENT } from '@angular/common';

declare var bootstrap: any;
@Component({
  selector: 'app-chat-dnb-widget',
  templateUrl: './chat-dnb-widget.component.html',
  styleUrls: ['./chat-dnb-widget.component.scss'],
})
export class ChatDnbWidgetComponent implements OnInit, AfterViewInit, AfterViewChecked {
@ViewChild('chatBody', { static: false }) chatBody!: ElementRef;

  isStreaming = false;
  public showLoader = false;
  public feedbackSubmitted: boolean = false;
  public thumbsUpClicked: boolean = false;
  public thumbsDownClicked: boolean = false;
  feedbackGiven: number | null = null;
  feedbackMap: { [key: number]: number } = {};
  pendingThumbDown: { [index: number]: boolean } = {};
  feedbackReasonText: { [index: number]: string } = {};
  submittedNegativeFeedback: { [index: number]: boolean } = {};
  shouldApplyChatOpen: any;
  // @Input('value')inputMessage = '';
  inputMessage: string = '';
  isChatOpen = true;
  isMinimized = false;
  isShortViewport = false;
  showWelcome = true;
  private shouldScroll = false;
  rectOld: any;
  origin: any;
  moveSubscription: any;
  div: any;
  alive: boolean = true;
  chatBoxHeight: string = '50%';
  isExpanded = false;

  messages: { sender: string; text: string }[] = [];
  promptResponses: { [key: string]: string } = {
    'hi': 'Hi! This is Chat D&B. How can I assist you today?',
    'hello': 'Hello! Welcome to Chat D&B. How can I help you?',
    'what is duns number ?': `Assigned to organizations by Dun & Bradstreet, a D-U-N-S number is a unique nine-digit identifier that is widely used to verify businesses. Organizations can use Dun & Bradstreet to see if they already have a D-U-N-S number, or request one for free. Many organizations already have a D-U-N-S number as part of doing business. You should check whether your organization has one before applying for a new one. You can do this by searching Dun and Bradstreet `,
    'how to reset my password?': 'You can reset your password by clicking on “Forgot Password” at the login screen of the D&B portal.',
    'thanks': 'You’re welcome! If you have any other questions, feel free to ask.',
    'test': `Assigned to organizations by Dun & Bradstreet, a D-U-N-S number is a unique nine-digit identifier that is widely used to verify businesses. Organizations can use Dun & Bradstreet to see if they already have a D-U-N-S number, or request one for free. Many organizations already have a D-U-N-S number as part of doing business. You should check whether your organization has one before applying for a new one. You can do this by searching Dun and Bradstreet `
  };
  constructor(private cdr: ChangeDetectorRef, private rd2: Renderer2, private homeService: HomeService, @Inject(DOCUMENT) private document: Document
  ) { }

  @HostListener('window:resize', [])
  onResize() {
    this.checkViewportHeight();
  }

  checkViewportHeight() {
    this.isShortViewport = window.innerHeight < 400;
  }

  scrollToBottom(): void {
  try {
    this.chatBody.nativeElement.scrollTop = this.chatBody.nativeElement.scrollHeight;
  } catch (err) {
    console.error('Scroll failed:', err);
  }
}

  toggleChat() {
    this.isChatOpen = !this.isChatOpen;
    this.adjustZIndex();
    if (this.isChatOpen) {
      this.minimizeDrift();
      this.checkOrientationAndApplyChatOpen();
      this.isMinimized = false;
      this.feedbackMap = {};
      this.pendingThumbDown = {};
      this.submittedNegativeFeedback = {};
      document.body.classList.remove('chat-closed');
      // this.enableDriftBlocker(); // Enable Drift when chat is open
    } else {
      // this.restoreDrift();
      document.body.classList.remove('chat-open');
      document.body.classList.add('chat-closed');
      this.shouldApplyChatOpen = false;
      // this.disableDriftBlocker(); // Disable Drift immediately
    }
    if (this.isChatOpen) {
      this.checkOrientationAndApplyChatOpen();
    } else {
      document.body.classList.remove('chat-open');
    }
  }

  // inputMessage: string = '';

ngAfterViewChecked(): void {
  // if (this.shouldScroll) {
  //   this.shouldScroll = false;
    this.scrollToBottom();
  // }
}

  ngAfterViewInit(): void {
    //     const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    //     tooltipTriggerList.forEach((tooltipTriggerEl) => {
    //       new bootstrap.Tooltip(tooltipTriggerEl, {
    //   placement: 'bottom'
    // });

    //     });
  }
  // exisisting
  onMessageEnter(): void {
    this.feedbackSubmitted = false;
    this.showWelcome = false;
    this.shouldScroll = true;
    const userInput = this.inputMessage.trim();
    if (!userInput) return;

    this.messages.push({ sender: 'user', text: userInput });

    const normalizedInput = userInput.toLowerCase();
    const botReply = this.promptResponses[normalizedInput];

    setTimeout(() => {
      this.messages.push({
        sender: 'bot',
        text: botReply || "I'm sorry, I didn't quite get that. Could you please rephrase?",
      });
      this.shouldScroll = true;

    }, 600);

    this.inputMessage = '';
  }

  startNewChat() {
    this.showWelcome = true;
    this.messages = [];
  }

  // onMessageEnter(): void {
  //   this.showWelcome = false;

  //   const userInput = this.inputMessage.trim();
  //   if (!userInput) return;

  //   this.messages.push({ sender: 'user', text: userInput });

  //   const botMessage = { sender: 'bot', text: '' };
  //   this.messages.push(botMessage);

  //   this.inputMessage = '';
  //   this.shouldScroll = true;
  //   this.isStreaming = true;
  //   this.showLoader = true;

  //   let hasFirstChunkArrived = false;

  //   this.homeService.streamMessage(
  //     userInput,
  //     (chunk: string) => {
  //       if (!hasFirstChunkArrived) {
  //         hasFirstChunkArrived = true;
  //         this.showLoader = false;
  //       }
  //       botMessage.text += chunk;
  //       this.shouldScroll = true;
  //       this.cdr.detectChanges();
  //     },
  //     () => {
  //       this.isStreaming = false;
  //       this.cdr.detectChanges();
  //       this.showLoader = false;
  //       console.log('Bot reply streaming complete');
  //     }
  //   );
  // }






  selectedFileName: string | null = null;

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file && (file.type === 'application/pdf' || file.type === 'application/msword' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')) {
      this.selectedFileName = file.name;
      // this.selectedFile = file;
    } else {
      alert('Only PDF or Word documents are allowed.');
    }
  }

  removeAttachment(): void {
    this.selectedFileName = null;
    // this.selectedFile = null;
  }

  // onFileSelected(event: Event): void {
  //   const input = event.target as HTMLInputElement;
  //   if (input.files && input.files.length > 0) {
  //     const file = input.files[0];
  //     this.inputMessage = `📎 ${file.name}`;
  //   }
  // }


  checkOrientationAndApplyChatOpen(): void {
    if (!this.isChatOpen) {
      this.shouldApplyChatOpen = false;
      return;
    }

    const isMobileLandscape = window.matchMedia('(max-width: 950px) and (orientation: landscape)').matches;

    this.shouldApplyChatOpen =
      (isMobileLandscape && !this.isMinimized) ||
      (this.isExpanded && !this.isMinimized);
  }
  get containerValue() {
    return this.isExpanded ? 'body' : null;
  }
  get containerValforMAxMin() {
    return this.isExpanded ? null : 'body';

  }


  private debouncedResize = () => {
    this.setVh();
    this.checkOrientationAndApplyChatOpen();
  };
  resizeHandler = () => this.checkOrientationAndApplyChatOpen();
  orientationHandler = () => this.checkOrientationAndApplyChatOpen();
  ngOnInit(): void {
    //  $('[data-toggle="tooltip"]').tooltip();
    this.isChatOpen = true;
    this.isMinimized = false;
    this.checkViewportHeight();
    this.messages = [];
    this.checkOrientationAndApplyChatOpen();
    // this.setVh();
    // const debounced = this.debounce(this.debouncedResize, 150);
    // window.addEventListener('resize', debounced);
    // window.addEventListener('orientationchange', debounced);
  }
  debounce(func: Function, wait: number) {
    let timeout: any;
    return (...args: any[]) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  minimizeDrift() {
    const driftRoot = document.getElementById('root') as HTMLElement;
    if (driftRoot) {
      driftRoot.style.width = '0';
      driftRoot.style.height = '0';
      driftRoot.style.overflow = 'hidden';
    }
  }

  restoreDrift() {
    const driftRoot = document.getElementById('root') as HTMLElement;
    if (driftRoot) {
      driftRoot.style.width = '100%';
      driftRoot.style.height = '100%';
      driftRoot.style.overflow = 'visible';
    }
  }

  adjustZIndex() {
    const chatIcon = document.querySelector('.header-right-icons img') as HTMLElement;
    const driftFrameController = document.querySelector('#drift-frame-controller') as HTMLElement;

    if (this.isMinimized) {
      if (chatIcon) chatIcon.style.zIndex = '99999'; // Increased z-index
      if (driftFrameController) driftFrameController.style.zIndex = '1';
    } else if (this.isChatOpen) {
      if (chatIcon) chatIcon.style.zIndex = '99999'; // Increased z-index
      if (driftFrameController) driftFrameController.style.zIndex = '999';
    } else {
      if (chatIcon) chatIcon.style.zIndex = '1'; // Increased z-index
      if (driftFrameController) driftFrameController.style.zIndex = '9999999'; // Set to 1 when closed
    }
  }


  toggleMinimize() {
    this.isMinimized = !this.isMinimized;
    setTimeout(() => {
      this.checkOrientationAndApplyChatOpen();
    }, 50);

    this.adjustZIndex();
  }

  // startVoiceInput(): void {
  //   const SpeechRecognition = (window as any).webkitSpeechRecognition || (window as any).SpeechRecognition;

  //   if (!SpeechRecognition) {
  //     alert("Speech recognition is not supported in this browser.");
  //     return;
  //   }

  //   const recognition = new SpeechRecognition();
  //   recognition.lang = 'en-US';
  //   recognition.interimResults = false;
  //   recognition.maxAlternatives = 1;

  //   recognition.onresult = (event: any) => {
  //     const voiceText = event.results[0][0].transcript;
  //     console.log('Voice input:', voiceText);

  //     this.inputMessage = voiceText;

  //     this.cdr.detectChanges(); 
  //   };

  //   recognition.onerror = (event: any) => {
  //     console.error('Voice recognition error:', event.error);
  //   };

  //   recognition.onend = () => {
  //     console.log('Speech recognition ended.');
  //   };

  //   recognition.start();
  // }

  showMenu: boolean = false;

  toggleMenu(): void {
    this.showMenu = !this.showMenu;
  }

  navigateTo(item: string): void {
    this.showMenu = false;
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.chat-menu') && !target.closest('.header-left-icon')) {
      this.showMenu = false;
    }
  }
  closeMenu() {
    this.showMenu = false;
  }

  submitFeedback(index: number, score: number) {
    this.feedbackGiven = score;
    this.feedbackMap[index] = score;
    if (score === 2) {
      this.submittedNegativeFeedback[index] = true;
      this.pendingThumbDown[index] = false;
    }
    const now = new Date();
    // let searchCriteria = sessionStorage.getItem("searchCriteria") || "";
    const siteHistory = sessionStorage.getItem('siteHistory') || '[]';
    let visitedPageCount = sessionStorage.getItem('visitedPageCount') || '0'
    let deviceType = sessionStorage.getItem('deviceType') || ""
    let browserName = sessionStorage.getItem('browserName') || ""
    let currentUrl = window.location.href
    let selectedTabId = sessionStorage.getItem('selectedTabId') || ""

    let dykTitle = '';
    if (dykTitle) {
      dykTitle = dykTitle.replace(/^"|"$/g, '');
    }
    let pageReferrer = sessionStorage.getItem("pageReferrer") || "Direct Visit";

    const formatDate = (date: Date) => {
      const pad = (n: number) => (n < 10 ? '0' + n : n);
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    };

    const currentDate = formatDate(now);
    const feedback: { values: any } = {
      values: {
        QID1: score,
        dykTitle: dykTitle,
        "Site History": siteHistory ? JSON.parse(siteHistory).join('|') : "",
        "Visited Page Count": visitedPageCount,
        "Device Type": deviceType,
        "Browser": browserName,
        "Current Page URL": currentUrl,
        "TAB_ID": selectedTabId,
        "DYK_Title_TAB01": "",
        "DYK_Title_TAB02": "",
        "DYK_Title_TAB03": "",
        "Page_Referrer": pageReferrer,
        "ThumbsDown_Reason":  this.feedbackReasonText[index] || ""
      },
    }
    if (score === 2) {
      feedback.values["ThumbsDown_Reason"] = this.feedbackReasonText[index] || ""
      if (this.messages && index < this.messages.length && this.messages[index]?.sender === 'bot') {
        feedback.values["chat_response"] = this.messages[index].text;
      }

      if (this.messages && index > 0 && this.messages[index - 1]?.sender === 'user') {
        feedback.values["user_input"] = this.messages[index - 1].text;
      }
    }
    this.homeService.postSurveyResponse(feedback).subscribe(
      (response: any) => {
        this.feedbackSubmitted = true;
      },
      error => {
        this.feedbackSubmitted = true;
      }
    );

  }
  size = 55;
  rows(str: string): number {
    const linesByLength = Math.floor(str.length / this.size);
    const lineBreaks = (str.match(/\n/g) || []).length;
    const totalLines = linesByLength + lineBreaks + 1;

    if (this.isExpanded) {
      return Math.min(Math.max(totalLines, 3), 5);
    } else {
      return Math.min(Math.max(totalLines, 1), 3);
    }
  }

  handleEnter(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    if (keyboardEvent.shiftKey) return;
    if (this.isStreaming) {
      keyboardEvent.preventDefault();
      return;
    }

    keyboardEvent.preventDefault();
    this.onMessageEnter();
  }

  toggleWidth() {
    this.isExpanded = !this.isExpanded;
    if (!this.isExpanded) {
      this.shouldApplyChatOpen = false;

    }
    setTimeout(() => {
      this.checkOrientationAndApplyChatOpen();
    }, 50);
  }
  setVh() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.debouncedResize);
    window.removeEventListener('orientationchange', this.debouncedResize);
  }
}